import { Download, File } from 'lucide-react';
import styles from './DocumentList.module.scss';

interface DocumentListItemProps {
  title: string;
  format: string;
  url: string;
}

interface DocumentListProps {
  documents: DocumentListItemProps[];
  testId?: string;
}

export const DocumentList: React.FC<DocumentListProps> = ({ documents, testId }) => (
  <ul className={styles.list} data-testid={testId}>
    {documents.map((document, index) => (
      <li className={styles.item} key={document.url}>
        <a
          href={document.url}
          title={`Ladda ned ${document.title} (${document.format})`}
          target="_blank"
          rel="noopener noreferrer nofollow"
          className={styles.document}
          data-testid={testId ? `${testId}-document-${index}` : undefined}
        >
          <File aria-hidden="true" />
          <span className={styles.title}>
            {document.title} ({document.format})
          </span>
          <Download aria-hidden="true" />
        </a>
      </li>
    ))}
  </ul>
);
